<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="critereRecherche">
    <div class="column is-12 pdb-0"
         :class="[{'hauteur-haut-brief-filtre': errors.length === 0},
      {'hauteur-haut-brief-filtre-errors': errors.length > 0}]">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('general.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('general.filtre.sousTitle') }}
        </span>
      </div>
      <div class="column is-12" v-if="hasError">
        <error-msg-component :messages="errors"
                             :error="hasError"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="closeErrorMsg"/>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless"
         :class="[{'hauteur-brief-filtre': errors.length === 0},
           {'hauteur-brief-filtre-errors': errors.length > 0}]">
      <div>
        <qd-notification type="is-primary" v-if="intervenantEcheance"
            @close="deleteIds()"  class="is-marginless pd-6px">
          <div>
            <span>
              {{ $t('listeFactureAchat.filtre.echeanceBail', {
                codeBail: codeBail,
                })}}
            </span>
            <br/>
            <span>
              {{ $t('listeFactureAchat.filtre.echeanceBailleur', {
                bailleur: intervenantEcheance,
                })}}
            </span>
            <br/>
            <span v-if="dateEcheance
            && dateEcheance.dateDebut && dateEcheance.dateFin">
              {{ $t('listeFactureAchat.filtre.echeancePeriode', {
                dateDebut: func.formatDate(dateEcheance.dateDebut) ,
                dateFin: func.formatDate(dateEcheance.dateFin)   ,
              })}}
            </span>
          </div>
        </qd-notification>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeFactureAchat.filtre.fournisseur')">
          <qd-taginput
            v-model="fournisseurSelected"
            icon="magnify"
            :data="filteredFournisseur"
            autocomplete
            type="is-primary"
            :loading="isFetching"
            field="nomCommercial"
            @typing="getFilteredFournisseur">
            <template slot="empty">
              <div v-if="!isFetching">
                {{$t('listeOrdreTravailAffichage.filtre.actions.noResult')}}
              </div>
              <div v-else>{{$t('listeOrdreTravailAffichage.filtre.actions.search')}}</div>
            </template>
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <libelle-tag-input
                      :label="$t('listeFactureAchat.filtre.etat')"
                      :items="constantes.FACTURE_ETAT"
                      v-model="etatsDevisCommandeFactureSelected">
        </libelle-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeFactureAchat.filtre.periode')">
          <div class="columns is-vcentered" >
            <b-datepicker show-week-number
                          class="column is-5"
                          icon="calendar-today"
                          :editable="true"
                          position="is-bottom-right"
                          v-model="critereRecherche.dates.dateDebut"
                          nearby-selectable-month-days>
            </b-datepicker>
            <div class="column is-2 has-text-centered has-text-default">
              {{ $t('general.au') }}
            </div>
            <b-datepicker show-week-number
                          class="column is-5"
                          icon="calendar-today"
                          :editable="true"
                          v-model="critereRecherche.dates.dateFin"
                          position="is-bottom-left"
                          nearby-selectable-month-days>
            </b-datepicker>
          </div>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <agence-tag-input
                      :label="$t('listeFactureAchat.filtre.agence')"
                      :items="agencesSelectionnees"
                      v-model="critereRecherche.agencesId">
        </agence-tag-input>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{ $t('general.button.appliquer') }}
      </button>

      <button @click="viderCritere()"
              class="button border-none mgt-10px has-text-icon-more pd-10px">
        {{ $t('general.button.reinitialiser') }}
      </button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import messageErreur from '@/services/general/messageErreur';
import { FACTURE_ETAT } from '@/configuration/facture/factureConf';
import { getAll } from '@/api/tiers/index';
import genererCritereRechercheFactureAchat from '@/services/baux/factureAchat/genererCritereRechercheFactureAchat';
import { TIERS_TYPE_FOURNISSEUR } from '@/configuration/tiers/tiersConf';
import { SET_CRITERE_RECHERCHE } from '@/store/modules/baux/factureAchat-mutation-type';
import { get } from '@/api/facture';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import agenceTagInput from '@/components/general/tagInput/agenceTagInput';
import formatDate from '@/services/general/formatDate';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');
const FactureAchat = createNamespacedHelpers('factureAchat');

export default {
  data() {
    return {
      errors: [],
      hasError: false,
      critereRecherche: null,
      constantes: {
        FACTURE_ETAT,
      },
      func: {
        formatDate,
      },
      fournisseurSelected: [],
      isFetching: false,
      filteredFournisseur: [],
      etatsDevisCommandeFactureSelected: [],
    };
  },
  components: {
    libelleTagInput,
    agenceTagInput,
    errorMsgComponent,
  },
  props: {
    intervenantEcheance: {
      type: String,
      required: false,
    },
    dateEcheance: {
      type: Object,
      required: false,
    },
    codeBail: {
      type: String,
      required: false,
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    ...FactureAchat.mapMutations({
      setCritereRecherche: SET_CRITERE_RECHERCHE,
    }),
    deleteIds() {
      this.critereRecherche.ids = [];
      this.critereRecherche.idsOrReferences = [];
      this.appliquerCritere();
    },
    closeErrorMsg() {
      this.errors = [];
      this.hasError = false;
    },
    checkError() {
      if (this.critereRecherche.dates.dateFin
        && this.critereRecherche.dates.dateDebut
        && moment(this.critereRecherche.dates.dateDebut)
          .isAfter(moment(this.critereRecherche.dates.dateFin))) {
        this.errors.push({
          message: 'listeFactureAchat.filtre.error.date',
        });
        this.hasError = true;
      }
    },
    appliquerCritere() {
      this.checkError();
      if (this.hasError) return;
      this.critereRecherche.etat = this.etatsDevisCommandeFactureSelected
        .map((e) => {
          return e.code;
        });
      this.critereRecherche.tiersId = this.fournisseurSelected;
      this.setCritereRecherche(this.critereRecherche);
      this.$emit('recherche', this.critereRecherche);
    },
    getFilteredFournisseur: debounce(async function getFournisseur(search) {
      this.filteredFournisseur = [];
      if (!search) return;
      this.isFetching = true;
      try {
        const fournisseurs = (await getAll(
          {
            query: {
              auto: search,
              type: TIERS_TYPE_FOURNISSEUR,
              societeId: this.societeActiveId,
              archive: false,
            },
          },
        )).data.result.items;
        this.filteredFournisseur = fournisseurs.filter((fournisseur) => {
          return !this.fournisseurSelected.map(
            fournisseurSelected => fournisseurSelected.id,
          ).includes(fournisseur.id);
        });
        this.isFetching = false;
      } catch (e) {
        this.isFetching = false;
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    viderCritere() {
      this.critereRecherche = {
        ...genererCritereRechercheFactureAchat(),
        idsOrReferences: this.critereRecherche.idsOrReferences,
      };
      this.etatsDevisCommandeFactureSelected = [];
      this.fournisseurSelected = [];
    },

    initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.listeEtatBase = cloneDeep(FACTURE_ETAT);
        this.critereRecherche = cloneDeep(this.criteresRechercheFromStore);
        this.fournisseurSelected = this.critereRecherche.tiersId;

        if (this.critereRecherche.ids) {
          const promiseFacture = [];
          this.critereRecherche.ids.forEach((factureId) => {
            promiseFacture.push(get(factureId));
          });
        }

        this.etatsDevisCommandeFactureSelected = this.listeEtatBase.filter((e) => {
          return this.critereRecherche.etat.includes(e.code);
        });

        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...FactureAchat.mapGetters({
      criteresRechercheFromStore: 'criteresRecherche',
    }),
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
      societeActiveId: 'societeActiveId',
    }),
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
